import React from "react";
import { setValueByIndex } from "../../../../utility/arrayUtils";
import RandomQuestion from "../../../results/randomQuestion";
import RanderSlot from "../RenderSlot";
import { slotConfs } from "../../../../constant/initDrawing";

function DrawingTable({ result, config, currentResult, setResult, className }) {
    const { tbH = "766px", tdH = "39px" } = config;

    const getResults = result.results.filter((_, i) => ![0, (result.results.length - 1)].includes(i));
    const slotResults = result.header;

    const onAfterReleaseCallback = (index, currentItem) => {

        const results = setValueByIndex(
            currentResult.results,
            currentItem.index,
            currentItem.value
        );

        setResult((prev) => ({
            ...prev,
            results,
            rightResults: [
                ...prev.rightResults.filter(e => e.columnNumber !== index + 1),
                ...currentResult.rightResults.filter(e => e.columnNumber === index + 1)
            ]
        }));
    }

    return (<div className={`w-50 d-flex justify-content-end ${className || ""}`}>
        <table style={{
            height: tbH
        }}>
            <tbody>
                {getResults.map((res, j) => {
                    const hlBG = config.hlIndex.includes(j);
                    const style = {
                        background: hlBG ? config.hlBG : config.background
                    }
                    return <React.Fragment key={j}>
                        {j === 0 ? <tr style={style} className={`row-${j}`}>
                            {slotResults.map((_, i) => {
                                return <td align="middle" key={`${j}_${i}`}>
                                    <RanderSlot
                                        currentResult={currentResult}
                                        key={i}
                                        index={i}
                                        onAfterReleaseCallback={onAfterReleaseCallback}
                                        config={slotConfs} />
                                </td>
                            })}
                        </tr>
                            : <tr style={style} className={`row-${j}`}>
                                {res.items.map((list, i) => {
                                    const style = config.row[`row_${j}`]
                                    return <td style={config.table?.td} align="middle" key={`${j}_${i}`}>
                                        {list.map((num, index) => {
                                            if (num.includes("*")) {
                                                return <div key={index} style={{ height: tdH }} />
                                            }
                                            if (num.includes("?")) {
                                                let randomSt = style?.random ? {
                                                    ...style.random,
                                                    background: config.random.background
                                                } : config.random
                                                return <div key={index} style={{ height: tdH }}>
                                                    <RandomQuestion className="random-res animate-kp-r" style={randomSt}
                                                        sizeDigit={num.length} />
                                                </div>
                                            }
                                            return <div className="scale-text" style={{ ...style?.normal, height: tdH }}
                                                key={index}>{num}</div>
                                        })}
                                    </td>
                                })}
                            </tr>
                        }
                    </React.Fragment>
                })}
            </tbody>
        </table>
    </div>
    );
}

export default DrawingTable;